<template>
  <div :id="`tooltip-${tooltipId}`" @click.prevent="tooltipClicked" aria-label="Tooltip" data-testid="tooltip">
    <slot />
  </div>
</template>

<script>
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/dist/backdrop.css'
import 'tippy.js/dist/border.css'
import 'tippy.js/dist/svg-arrow.css'
import 'tippy.js/themes/light.css'
export default {
  name: 'ellevio-web-tooltip',
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    identifier: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: 'top'
    }
  },
  data() {
    return {
      tippyInstance: null,
      isMobile: true
    }
  },
  computed: {
    matchMediaMobileQuery() {
      return window.matchMedia(' (min-width: 900px) ')
    },
    tooltipId() {
      return this.identifier || Math.floor(Math.random() * 1000 + 1)
    }
  },
  methods: {
    tooltipClicked() {
      if (this.active) {
        if (this.isMobile && this.tippyInstance && this.tippyInstance[0]) {
          if (this.tippyInstance[0].state.isShown) {
            this.tippyInstance[0].hide(200)
          } else {
            this.tippyInstance[0].show(200)
          }
        }
      }
    },
    resize: function () {
      this.isMobile = this.matchMediaMobileQuery ? !this.matchMediaMobileQuery.matches : true
    }
  },
  mounted() {
    if (this.active) {
      this.isMobile = this.matchMediaMobileQuery ? !this.matchMediaMobileQuery.matches : true
      this._boundedResize = this.resize.bind(this)
      window.addEventListener('resize', this._boundedResize)

      const contentExist = (this.content && this.content.length > 0) || (this.title && this.title.length > 0)

      if (contentExist) {
        this.$nextTick(() => {
          this.tippyInstance = tippy(`#tooltip-${this.tooltipId}`, {
            theme: 'light',
            zIndex: 100000,
            placement: this.placement,
            allowHTML: true,
            hideOnClick: false,
            content: `<div class="tooltip-inner">${this.title.length > 0 ? `<strong>${this.title}</strong><br/>` : ''}${this.content}</div>`
          })
        })
      }
    }
  }
}
</script>

<style scoped>
[id^='tooltip-'] {
  min-width: 20px;
  width: auto;
  height: auto;
  font-size: 1.9rem;
  /*font-size: 18px !important;*/
}
.tippy-box[data-theme~='light'] {
  /* override theme box shadow (tailwind shadow-md + small adjustment) */
  box-shadow: 0 4px 6px 1px rgb(0 0 0 / 0.1), 0 2px 4px 0 rgb(0 0 0 / 0.1);
}
.tooltip-inner {
  font-size: 18px !important;
  line-height: 24px;
  padding: 6px;
}
</style>
